<template>
  <div class="null-data flex-ccc">
    <img :src="img" />
    <div class="desc">{{desc}}</div>
  </div>
</template>

<script>
  export default {
    props: {
      img: {
        type: null,
        default: '/static/images/content-null.png'
      },
      desc: {
        type: null,
        default: '暂无内容'
      }
    }
  }
</script>

<style lang="less" scoped>
  .null-data {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    img {
      .w(2rem);
    }
    .desc {
      .fz(.28rem);
      .c(#999);
      .mt(.23rem);
    }
    .btn {
      .mt(.50rem);
      .w(3.00rem);
    }
  }
</style>
